import { Box, useTheme } from "@mui/material";
import React from "react";
import { Base } from ".";

export interface TabProps {
  label: string;
  hideTab?: boolean;
}

interface Props {
  index: number;
  activeTab: number;
  activeBackgroundColor?: string;
  icon?: any;
  color?: string;
  disabled?: boolean;
}

const Tab: React.FC<TabProps & Props> = (props) => {
  const {
    label,
    index,
    activeTab,
    activeBackgroundColor,
    icon,
    color,
    disabled,
  } = props;
  const theme = useTheme();
  return (
    <Box
      key={label}
      className={index === activeTab ? "active" : ""}
      sx={{
        background:
          index === activeTab
            ? activeBackgroundColor ?? theme.palette.primary.main
            : disabled
            ? `#ededed`
            : theme.palette.text.secondary,
        padding: "15px",
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
        color:
          index === activeTab
            ? theme.palette.primary.contrastText
            : disabled
            ? theme.palette.text.primary
            : color || theme.palette.secondary.contrastText,
        cursor: disabled ? "not-allowed" : "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        maxHeight: "54px",
      }}
    >
      {icon}
      <Base.Text text={label} center />
    </Box>
  );
};

export default Tab;
